import { useQuery as useMilestonesQuery } from "@faire/web-api--source/endpoints/www/api/user/milestones/userToken/list/get-hooks";
import { IGetUserMilestonesResponse } from "@faire/web-api--source/indigofair/data/IGetUserMilestonesResponse";
import { IUserMilestone } from "@faire/web-api--source/indigofair/data/IUserMilestone";

import { getUser } from "../serialized-data/getUser";
import { getUserMilestones } from "../serialized-data/getUserMilestones";

type MilestoneType = "BRAND_MILESTONE" | "RETAILER_MILESTONE";

interface IMilestonesData {
  isLoading: boolean;
  milestones: Partial<Record<string, IUserMilestone>> | undefined;
}

const getInitialMilestoneData = (milestoneType: MilestoneType) => {
  const milestones = getUserMilestones();
  if (!milestones) {
    return undefined;
  }

  const milestoneKey =
    milestoneType === "BRAND_MILESTONE"
      ? "brand_milestone"
      : "retailer_milestone";

  return IGetUserMilestonesResponse.build({
    milestones: milestones.reduce(
      (acc, milestone) => ({
        ...acc,
        [milestone[milestoneKey]!]: milestone,
      }),
      {} as Record<string, IUserMilestone>
    ),
  });
};

export const useMilestonesData = (
  milestoneType: MilestoneType
): IMilestonesData => {
  const userToken = getUser()?.token;
  const { data, isLoading } = useMilestonesQuery(userToken ?? "", {
    initialData: getInitialMilestoneData(milestoneType),
    enabled: !!userToken,
    staleTime: Infinity,
  });
  return { isLoading, milestones: data?.milestones };
};
